import { api } from 'api'
import { toaster } from 'uikit/Toaster'
import { useMutation } from '@tanstack/react-query'

export const useUpdateRewards = () => {
  return useMutation({
    mutationFn: (data) => api.referral.rewardDistribution(data),
    onError: (err) => {
      toaster.create({
        type: 'error',
        title: 'Произошла ошибка при начислении бонусов',
        description: err.message,
      })
    },
    onSuccess: (data) => {
      toaster.create({
        type: 'success',
        title: 'Данные успешно внесены',
      })
    },
  })
}
